import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const RiskRegimeTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();

    const data = rows.filter(row => row.Category === "RISK_REGIME");

    return <EconomicTable data={data} title="Risk Regime Analysis" defaultRowData={{ Category: "RISK_REGIME", Topic: "VIX" }} groupBy="Topic" groupOrder={["VIX", "Term Structure", "Expected Move"]} useDataHook={useMarketInternalsData} />;
};

export default RiskRegimeTab;
